import React from "react";
import PropTypes from "prop-types";

import IconButton from "components/IconButton";

import leftArrow from "components/assets/images/school_money/arrow-left.svg";
import rightArrow from "components/assets/images/school_money/arrow-right.svg";

import "./QuantitySelector.css";

export default class QuantitySelector extends React.Component {
  
  static propTypes = {
    quantity: PropTypes.number.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    className: PropTypes.string,
    // onChange args: (newQuantity, oldQuantity)
    onChange: PropTypes.func.isRequired
  }
  
  static defaultProps = {
    min: 1,
    max: Infinity
  }
  
  canChangeTo(newQuantity) {
    const { quantity, min, max } = this.props;
    return (
      // don't fire onChange if the value is the same
      newQuantity !== quantity &&
      // check min and max bounds
      newQuantity >= min &&
      newQuantity <= max
    );
  }
  
  onChange(newQuantity) {
    if (this.canChangeTo(newQuantity)) {
      this.props.onChange(newQuantity, this.props.quantity);
    }
  }
  
  increase = () => {
    this.onChange(this.props.quantity + 1);
  }
  
  decrease = () => {
    this.onChange(this.props.quantity - 1);
  }
  
  render() {
    
    const { quantity, className } = this.props;
    const canIncrease = this.canChangeTo(quantity + 1);
    const canDecrease = this.canChangeTo(quantity - 1);
    
    const classNames = [ "quantity-selector" ];
    if (className) {
      classNames.push(className);
    }
    if (!canIncrease) {
      classNames.push(`quantity-selector--no-increase`);
    }
    if (!canDecrease) {
      classNames.push(`quantity-selector--no-decrease`);
    }
    
    return (
      <div className={classNames.join(" ")}>
        <IconButton className="quantity-selector__arrow quantity-selector__arrow--decrease" src={leftArrow} onClick={this.decrease} />
        <span className="quantity-selector__quantity">{this.props.quantity}</span>
        <IconButton className="quantity-selector__arrow quantity-selector__arrow--increase" src={rightArrow} onClick={this.increase} />
      </div>
    );
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/QuantitySelector.js